<!-- 经纪人列表弹窗 -->
<template>
  <b-modal v-model="isShow" :title="modalTitle" centered scrollable no-close-on-backdrop @hide="onReset"
    id="agentListModal">
    <div id="agentListModal" class="body-content">
      <!-- UID -->
      <b-row class="line">
        <b-col>
          <label><i class="text-danger mar-r-2">*</i>{{ $t("lanV4.newUid") }}</label>
          <b-input-group>
            <b-form-input class="append-input" v-model.trim="$v.form.uid.$model" autocomplete="off" maxLength="10"
              :state="chkState('uid')" :class="{ 'invalid-select-border': !$v.form.uid.required }" placeholder=""
              :disabled="modalType == 'Edit' ? true : false">
            </b-form-input>
            <div class="append"></div>
          </b-input-group>
          <p class="user-info" v-if="userInfo">
            <span> {{ $t("lanV4.userInfo") }}: </span>
            <span>
              <span v-if="userInfo" style="margin-right: 10px">{{
                userInfo.mobileNumber
                }}</span>
              <span v-if="userInfo">{{ userInfo.email }}</span>
            </span>
          </p>
          <p class="text-danger" v-if="!$v.form.uid.required">
            {{ $t("lanV4.UidErr") }}
          </p>
        </b-col>
      </b-row>
      <!-- 角色 -->
      <b-row class="line">
        <b-col>
          <label><i class="text-danger mar-r-2">*</i>{{ $t("lanV4.agentRoleName") }}</label>
          <v-select v-model="$v.form.roleName.$model" :options="roleNameList" :state="chkState('roleName')">
            <div slot="no-options">{{ $t("common.noFind") }}</div>
          </v-select>
          <p class="text-danger" v-if="!$v.form.roleName.required">
            <!-- 请选择角色 -->
            {{ $t("userManagement.roleEmpty") }}
          </p>

          <div class="roleName-tip" v-if="form.roleName">
            <div class="text-1" v-if="form.roleName.roleType == 1">
              <!-- 最高返佣等级 -->
              {{ $t("lanV4.RebateratioLever") }}: {{ form.roleName.maxLevel }}
            </div>

            <div class="text-2" v-for="(item, index) in form.roleName.scaleInfo" :key="index">
              <!-- 返佣比例 -->
              <!-- {{ $t("lanV4.Rebateratio") }}:{{ form.roleName.returnScale }} -->
              {{ item.key }}:{{ item.value }}
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- 备注 -->
      <b-row class="line">
        <b-col>
          <label><i class="text-danger mar-r-2"></i>{{ $t("transfer.remark") }}</label>
          <b-input-group>
            <b-form-input class="append-input" v-model.trim="form.desc" autocomplete="off" placeholder=""
              maxLength="19">
            </b-form-input>
            <div class="append"></div>
          </b-input-group>
        </b-col>
      </b-row>
      <!-- 邮件提醒 -->
      <b-row class="line email-tip">
        <b-col>
          <el-checkbox size="medium" v-model="form.emailSwitch">{{ $t('editInvitationCode.emailTip') }}</el-checkbox>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer>
      <b-button class="coustom-btn" variant="primary" @click="save">{{
        $t("common.save")
        }}</b-button>
      <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
        $t("common.cancel")
        }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import { requiredIf } from "vuelidate/lib/validators";
import { newFixInput, multiply, divide, fixD } from "@/apis/newmethods";
export default {
  name: "futuresFeeModal",
  props: ["modalShow", "modalType", "itemData", "brokerId"],
  data() {
    return {
      tipWidth: "200px",
      isShow: false,
      modalTitle: null,
      userInfo: null, //用户信息
      form: {
        uid: null, //uid
        roleName: null, //角色名称
        desc: null, //备注
        emailSwitch: false,//发送邮箱开关
      },
      pickerOptions1: {
        // 禁用今天之前日期
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 8.64e7;
        // },
      },
      actStartTimeErr: false, //有效期开始日期必须小于结束日期
      addSave: false,
      saveFlag: true, //保存防二次点击
      timeout: null,
      roleNameList: [], //角色名称列表
      roleNameListAll: [], //角色名称所有数据
    };
  },
  watch: {
    // 商户id
    "form.brokerId"(v) {
      if (v) {
        this.$nextTick(() => {
          if (this.modalType !== "Edit") {
          }
        });
      }
    },
    // uid
    "form.uid"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.uid = newFixInput(v, 0, {
            num: true,
            ints: 10,
          });
        });
        if (this.modalType === "Add") {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            if (this.form.uid != "") {
              this.getUidUserInfo();
            }
          }, 1000);
        }
      }
    },

    modalShow(v) {
      this.isShow = v;
    },
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError;
    },
    url() {
      return this.$store.state.url.agent;
    },
    editDisabled() {
      if (this.modalType === "Edit") {
        return true;
      } else {
        return false;
      }
    },
    roleType() {
      if (this.$store.state.baseData.user) {
        return this.$store.state.baseData.user.roleType;
      }
    },
  },
  created() {
    if (this.modalType && this.modalType === "Add") {
      this.modalTitle = this.$t("lanV4.addBroker");
    } else if (this.modalType && this.modalType === "Edit") {
      this.modalTitle = this.$t("lanV4.editBroker");
      if (this.itemData) {
        this.getUidUserInfo();
      }
    }
    this.isShow = this.modalShow;
    this.getRoleNameListAll();
    this.getRoleNameList();
  },
  validations: {
    form: {
      // uid
      uid: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
      //角色
      roleName: {
        required: requiredIf(function () {
          return this.addSave;
        }),
      },
    },
  },
  methods: {
    // 乘法
    multiply(v1, v2) {
      return multiply(v1, v2);
    },
    // 除法
    divide(v1, v2) {
      return divide(v1, v2);
    },
    // 获取uid用户信息
    getUidUserInfo() {
      this.$http({
        url: this.$store.state.url.agent.get_user_info,
        params: {
          uid: this.modalType === "Add" ? this.form.uid : this.itemData.uid,
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.userInfo = data;
          this.getRoleNameList();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },

    //   获取角色名称列表(不包含所有的)
    getRoleNameList() {
      this.$http({
        url: this.$store.state.url.agent.co_agent_role_menu_list,
        params: {
          uid: this.modalType === "Add" ? this.form.uid : this.itemData.uid,
          hasScaleLimit: 1, //限制最大比例
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          //   arr.push({ label: this.$t("common.all"), value: null });
          data.map((item, index) => {
            arr.push({
              label: item.name,
              value: item.id,
              maxLevel: item.maxLevel,
              scaleInfo: item.scaleInfo,
              roleType: item.roleType,
            });
          });
          this.roleNameList = arr;
          if (this.modalType == "Add") {
            this.form.roleName = arr[0];
          } else {
            this.setEditData();
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 包含所有的
    getRoleNameListAll() {
      this.$http({
        url: this.$store.state.url.agent.co_agent_role_menu_list,
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          data.map((item, index) => {
            arr.push({
              label: item.name,
              value: item.id,
              maxLevel: item.maxLevel,
              scaleInfo: item.scaleInfo,
              roleType: item.roleType,
            });
          });
          this.roleNameListAll = arr;
          if (this.modalType === 'Edit') {
            this.setEditData()
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    //编辑设置
    setEditData() {
      if (this.itemData) {
        // 角色名称
        this.roleNameListAll.map((item) => {
          if (this.itemData.roleId == item.value) {
            this.form.roleName = item;
          }
        });
        // 用户UID
        this.form.uid = this.itemData.uid;
        this.form.desc = this.itemData.desc;
      }
    },
    // 保存
    save() {
      this.addSave = true;
      if (!this.validate()) {
        // this.$bus.$emit("alert", {
        //   type: "error",
        //   message: this.$t("lanV4.infoErr"),
        // });
        return;
      }
      if (!this.saveFlag) return;
      this.saveFlag = false;
      const url =
        this.modalType === "Add"
          ? this.url["co_agent_user_set"]
          : this.url["co_agent_user_set"];

      const paramsData = {
        uid: this.form.uid,
        roleId: this.form.roleName ? this.form.roleName.value : null,
        desc: this.form.desc,
        status: this.modalType === "Add" ? 3 : 4, //有效
        sendEmail: this.form.emailSwitch ? 1 : 0,
      };
      this.$http({
        url: url,
        params: paramsData,
      }).then((data) => {
        this.saveFlag = true;
        if (data && data.code.toString() === "0") {
          this.$bus.$emit("alert", {
            type: "success",
            message: this.$t("publicManage.lanset.saveSuccess"),
          });
          // this.$parent.getData();
          setTimeout(() => {
            this.$parent.addGetTime();
          }, 500);
          this.onReset();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    onReset() {
      this.modalTitle = null;
      this.addSave = false;
      this.form.name = null; //配置名称
      this.$emit("changeModalShow", false);
      this.$emit("changeModalType", null);
      this.$v.form.$reset();
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
  },
};
</script>

<style lang="scss">
#agentListModal {
  .email-tip {
    position: relative;
    left: -10px;
    top: -10px;

    .el-checkbox__label {
      color: #263954;
    }

    .el-checkbox.is-checked {
      background: #fff !important;
    }

    .el-checkbox__inner {
      width: 14px !important;
      height: 14px !important;
      position: relative;
      top: -1px;
    }

    .el-checkbox__input.is-focus {
      .el-checkbox__inner {
        border-color: #DCDFE6 !important;
      }
    }

    .el-checkbox__input.is-checked {
      .el-checkbox__inner {
        border-color: #095BE8 !important;
      }
    }


  }

  .modal-body {
    overflow: visible !important; //控制输入框显示层级
  }

  .vs__dropdown-menu {
    height: 114px !important;
  }

  .user-info {
    color: #93979d !important;
    margin: 0;
    margin-top: 4px;
    display: flex;
  }

  .form-control {
    &::-webkit-input-placeholder {
      color: #93979d !important;
    }
  }

  .roleName-tip {
    // height: 64px;
    background: #f7f8fa;
    margin-top: 16px;
    border-radius: 4px;
    padding: 8px 12px;
    color: #263954;
    font-family: HarmonyOS-Regular;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    max-height: 300px;
    overflow-y: scroll;
    .text-2 {
      margin-top: 8px;
    }
  }

  .row {
    line-height: 20px;
    margin-bottom: 18px;
  }

  label {
    margin: 0;
  }

  .td {
    margin-left: 0px;
  }

  .coustom-icon {
    cursor: pointer;
  }

  .line-text {
    display: block;
    width: 570px;
    clear: both;
    box-sizing: border-box;
    padding-left: 10px;
    margin-bottom: 5px;

    .f-r {
      float: right;
    }
  }

  p.text-danger {
    margin: 0;
    line-height: 21px;
  }
}
</style>